import { Colors } from '../../theme'

export default {
  color: Colors.Palette.whiteColor,
  fontSize: '0.77rem',
  fontWeight: 500,
  textTransform: 'none',
  width: '100% !important',
  height: 44
}



// WEBPACK FOOTER //
// ./src/styles/buttons/raised.js